/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '../icon/icon'

const CheckmarkCircleIconSvg = forwardRef((props, svgRef) => (
	<svg
		width={props.width || (props.height && Math.floor(+props.height * 1)) || 24}
		height={props.height || (props.width && Math.floor(+props.width / 1)) || 24}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		fontSize="medium"
		ref={svgRef}
		{...props}
	>
		<path
			d="M12 1.2c5.965 0 10.8 4.835 10.8 10.8 0 5.965-4.835 10.8-10.8 10.8-5.965 0-10.8-4.835-10.8-10.8C1.2 6.035 6.035 1.2 12 1.2zm0 2.4a8.4 8.4 0 100 16.8 8.4 8.4 0 000-16.8zm4.183 3.85c.855-.679 2.108.135 1.756 1.14a1.038 1.038 0 01-.205.347L10.8 16.8l-4.33-3.49a1.17 1.17 0 01-.367-.518l-.044-.127c-.244-.697.3-1.416 1.071-1.416.245 0 .482.076.678.215L10.2 13.2l5.983-5.75z"
			fill="currentColor"
			fillRule="evenodd"
		/>
	</svg>
))
CheckmarkCircleIconSvg.displayName = 'CheckmarkCircleIconSvg'

const CheckmarkCircleIcon = forwardRef((props, ref) => <Icon component={CheckmarkCircleIconSvg} ref={ref} {...props} />)
CheckmarkCircleIcon.displayName = 'CheckmarkCircleIcon'

CheckmarkCircleIcon.defaultProps = {
	...Icon.defaultProps,
}
CheckmarkCircleIcon.propTypes = {
	...Icon.propTypes,
}

export default CheckmarkCircleIcon
export { CheckmarkCircleIconSvg }
